import React, { ForwardedRef, ReactElement, ReactNode } from "react";
import Select, {
  GroupBase,
  OptionsOrGroups,
  SelectInstance,
} from "react-select";
import useTailwindBreakpoints from "../../../../hooks/useTailwindBreakPoints";
import { useTheme } from "../../../../theme/ThemeProvider";

interface SelectBoxProps {
  className?: string;
  options: OptionsOrGroups<any, GroupBase<any>>;
  isSearchable?: boolean;
  isMulti?: boolean;
  indicator?: ReactElement;
  shape?: "round";
  variant?: "fill";
  size?: "xs";
  color?: "white_A700";
  onChange?: (option: any) => void;
  value?: any;
  children?: ReactNode;
}

const variants = {
  fill: {
    white_A700: "bg-white-A700 text-blue_gray-300",
  },
};

const getThemeColors = (theme: string, type: string) => {
  if (theme === "aub" && type !== "hover") return "#06486C";
  if (theme === "aub" && type === "hover") return "#D3940F";
  else return "#dc524c";
};
const Selector = React.forwardRef(
  (
    {
      children,
      className = "",
      options = [],
      isSearchable = false,
      isMulti = false,
      indicator,
      shape,
      variant = "fill",
      size = "xs",
      color = "white_A700",
      ...restProps
    }: SelectBoxProps,
    ref: ForwardedRef<SelectInstance<any, boolean, GroupBase<any>>>
  ) => {
    const { "5xl": fxl } = useTailwindBreakpoints();
    const { theme } = useTheme();
    return (
      <>
        <Select
          options={options}
          ref={ref}
          className={`${className}  border border-blue_gray-50_04 rounded-lg flex ${
            shape || ""
          } xs:h-[38px] 5xl:h-[54px] pl-4 xs:text-xs 5xl:text-lg ${
            variants[variant]?.[color] || ""
          }`}
          isSearchable={isSearchable}
          isMulti={isMulti}
          components={{
            IndicatorSeparator: () => null,
            ...(indicator && { DropdownIndicator: () => indicator }),
          }}
          styles={{
            container: (provided) => ({
              ...provided,
              zIndex: 0,
            }),
            control: (provided) => ({
              ...provided,
              backgroundColor: "transparent",
              border: "0 !important",
              boxShadow: "0 !important",
              minHeight: "auto",
              width: "100%",
              "&:hover": {
                border: "0 !important",
              },
            }),
            input: (provided) => ({
              ...provided,
              color: "inherit",
            }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: state.isSelected
                ? getThemeColors(theme, "selected")
                : "transparent",
              color: state.isSelected ? "#ffffff" : "inherit",
              "&:hover": {
                backgroundColor: getThemeColors(theme, "hover"),
                color: "#ffffff",
              },
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: 0,
              textAlign: "left",
            }),
            placeholder: (provided) => {
              console.log(provided);
              return {
                ...provided,
                fontSize: fxl ? "20px" : "12px",
                color: "#98A2B3",
                margin: 0,
              };
            },
            menuPortal: (base) => ({ ...base, zIndex: 999999 }),
          }}
          menuPortalTarget={document.body}
          placeholder={"Choose"}
          {...restProps}
        />
        {children}
      </>
    );
  }
);

export default Selector;
